export default __webpack_public_path__ + "static/media/17.8d2908d2.png";